import React from "react";
import styled from 'styled-components'
import { breakpoint } from 'styled-components-breakpoint';
import IframeResizer from 'iframe-resizer-react'
import PageWrapper from "./pageWrapper";

const IframeContainer = styled.div`
  width: 100%;
  background-color: #fff;
  padding: 0px 20px;
  h2{
    position: relative;
  }
  iframe{
      margin: -20px -15px 10px;
  }
`


function ContactForm(props) {   

    return (
        <PageWrapper>
            <IframeContainer>
                <h2>We horen graag van u</h2>
                <IframeResizer
                    src="https://formlets.com/forms/WS952nDgJmDue2as/?iframe=true&nofocus=y"
                    style={{ width: '1px', minWidth: '100%', border: '0'}}
                />
                <script type="text/javascript" src="https://formlets.com/static/js/iframe.js"></script>
            </IframeContainer>
        </PageWrapper>
    )

}
export default ContactForm;

